import React, { useState, useEffect, useCallback } from 'react'
import { Box, useTheme } from '@mui/material'

import TechnologySelectionStep from './launchCampaignComponents/TechnologySelectionStep'
import CampaignPreviewStep from './launchCampaignComponents/CampaignPreviewStep'

import { commonDrawerPadding } from './launchCampaignComponents/launchCampaignStyles'
import {
  useGetCurrentServicesQuery,
  useGetServicesQuery,
  useUpdateUsedServicesMutation
} from '../../../../api/onboardingApiSlice'
import useMutation from '../../../../hooks/useMutation'

const STEPS = {
  SELECT_TECHNOLOGIES: 'select_technologies',
  PREVIEW_CAMPAIGN: 'preview_campaign'
}

export default function LaunchCampaignView({ onClose, currentStepDetails, completeStepAndProceed }) {
  const theme = useTheme()

  const [currentSubStep, setCurrentSubStep] = useState(STEPS.SELECT_TECHNOLOGIES)

  const [selectedTechnologies, setSelectedTechnologies] = useState([])
  const [searchTerm, setSearchTerm] = useState('')

  const { data: allTechnologies, isLoading } = useGetServicesQuery()
  const { data: currentServices, isLoading: isCurrentServicesLoading } = useGetCurrentServicesQuery()

  const { submit: submitTechnologies, isLoading: isSubmitting } = useMutation(useUpdateUsedServicesMutation, {
    showSuccessToast: false,
    onSuccess: () => {
      setCurrentSubStep(STEPS.PREVIEW_CAMPAIGN)
    }
  })

  useEffect(() => {
    if (currentServices) {
      setSelectedTechnologies(currentServices?.usedProducts)
    }
  }, [currentServices])

  const handleToggleTechnology = useCallback(tech => {
    setSelectedTechnologies(prev => {
      const isSelected = prev.some(selected => selected === tech)
      if (isSelected) {
        return prev?.filter(t => t !== tech)
      }
      return [...prev, tech]
    })
  }, [])

  const handleSearchTermChange = event => {
    setSearchTerm(event.target.value)
  }

  const handleContinueToPreview = () => {
    submitTechnologies(selectedTechnologies)
  }

  const handleBackToSelection = () => {
    setCurrentSubStep(STEPS.SELECT_TECHNOLOGIES)
  }

  const handleLaunchCampaign = async launchData => {
    if (currentStepDetails && completeStepAndProceed) {
      completeStepAndProceed(currentStepDetails.id, {
        status: 'success',
        modalData: {
          campaignName: 'Initial Simulation Campaign',
          ...launchData
        }
      })
    }
  }

  if (isLoading || isCurrentServicesLoading) {
    return <Box sx={commonDrawerPadding(theme)}>Loading services...</Box>
  }

  return (
    <Box sx={commonDrawerPadding(theme)}>
      {currentSubStep === STEPS.SELECT_TECHNOLOGIES && (
        <TechnologySelectionStep
          isSubmitting={isSubmitting}
          allTechnologies={allTechnologies}
          selectedTechnologies={selectedTechnologies}
          onToggleTechnology={handleToggleTechnology}
          searchTerm={searchTerm}
          onSearchTermChange={handleSearchTermChange}
          onContinue={handleContinueToPreview}
          onBack={onClose}
        />
      )}
      {currentSubStep === STEPS.PREVIEW_CAMPAIGN && (
        <CampaignPreviewStep
          onLaunch={handleLaunchCampaign}
          onBack={handleBackToSelection}
          selectedTechnologies={selectedTechnologies}
        />
      )}
    </Box>
  )
}
